export const getLangFromQuery = (search: string): string => {
  const supportedLangs = ["en", "es"];
  const params = new URLSearchParams(search);

  // 1. Check for ?locale=es
  const localeParam = params.get("locale");
  if (supportedLangs.includes(localeParam ?? "")) {
    return localeParam!;
  }

  // 2. Check for ?es or ?en (flag form)
  const flag = supportedLangs.find((lang) => params.has(lang));
  return flag ?? "en";
};
